import React, { useState, useEffect } from 'react';
import './ActualitesSection.css';
import { FaFacebook, FaNewspaper } from 'react-icons/fa';
import useInView from '../../hooks/useInView';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';

const FACEBOOK_PAGE_URL = 'https://www.facebook.com/efafc.footballclub';

export default function ActualitesSection() {
  const [tab, setTab] = useState('facebook');
  const [articles, setArticles] = useState([]);
  const [articlesLoading, setArticlesLoading] = useState(true);
  const [articlesError, setArticlesError] = useState(null);
  const [refTitle, inViewTitle] = useInView();

  useEffect(() => {
    async function loadArticles() {
      try {
        setArticlesLoading(true);
        const q = query(collection(db, 'articles'), orderBy('date', 'desc'));
        const snap = await getDocs(q);
        setArticles(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (e) {
        setArticlesError('Erreur lors du chargement des articles.');
      } finally {
        setArticlesLoading(false);
      }
    }
    loadArticles();
  }, []);

  return (
    <section id="actualites" className="w-full max-w-6xl mx-auto px-4 py-10 relative mt-24">
      {/* Titre géant animé */}
      <div
        ref={refTitle}
        className={`absolute inset-x-0 -top-16 max-w-6xl mx-auto px-4 flex justify-center pointer-events-none select-none z-0 transition-all duration-700 ${inViewTitle ? 'animate-fadeUp' : 'opacity-0 translate-y-10'}`}
      >
        <span className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold opacity-20 leading-none whitespace-nowrap tracking-tight" style={{letterSpacing: '-0.03em'}}>ACTUALITÉS</span>
      </div>
      <h2 className="sr-only">Actualités du club</h2>
      {/* Tabs */}
      <div className="flex justify-center gap-4 mb-10 z-10 relative">
        <button className={`tab-btn ${tab==='facebook' ? 'active' : ''}`} onClick={()=>setTab('facebook')} aria-label="Facebook"><FaFacebook className="mr-2"/>Facebook</button>
        <button className={`tab-btn ${tab==='articles' ? 'active' : ''}`} onClick={()=>setTab('articles')} aria-label="Articles"><FaNewspaper className="mr-2"/>Articles</button>
      </div>
      {/* Contenu des tabs */}
      <div className="glass-section rounded-3xl p-6 border border-white/20 shadow-2xl relative overflow-hidden min-h-[520px]">
        {tab === 'facebook' && (
          <div className="flex flex-col items-center justify-center h-full">
            <iframe
              title="Facebook Feed"
              src={`https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(FACEBOOK_PAGE_URL)}&tabs=timeline&width=500&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`}
              width="100%"
              height="500"
              style={{border:'none',overflow:'hidden',borderRadius:'1.5rem'}}
              scrolling="no"
              frameBorder="0"
              allowFullScreen={true}
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              className="bg-white/10"
            ></iframe>
          </div>
        )}
        {tab === 'articles' && (
          <div>
            {articlesLoading ? <div className="text-center py-8">Chargement des articles…</div> :
            articlesError ? <div className="text-center text-red-500 py-8">{articlesError}</div> :
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {articles.length === 0 && <div className="col-span-full text-center text-blue-200">Aucun article pour le moment.</div>}
              {articles.map(article => (
                <div key={article.id} className="bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col group hover:scale-[1.03] transition h-[500px] min-h-[500px] max-h-[500px]">
                  {article.image && (
                    <img
                      src={article.image}
                      alt={article.titre}
                      className="w-full h-64 object-cover group-hover:scale-105 transition"
                    />
                  )}
                  <div className="p-5 flex flex-col flex-1">
                    <h3 className="text-lg font-bold text-[#001B56] mb-2 line-clamp-2">{article.titre}</h3>
                    <p className="text-sm text-gray-600 mb-4 line-clamp-3">{article.extrait || article.texte?.slice(0,120)+'…'}</p>
                    <a
                      href={article.lien || '#'}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-auto inline-block bg-[#FFE400] text-[#001B56] font-extrabold rounded-xl px-5 py-2 text-center hover:bg-[#BDFF00] transition"
                    >
                      Lire la suite
                    </a>
                  </div>
                </div>
              ))}
            </div>
            }
          </div>
        )}
      </div>
    </section>
  );
} 